<template>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 pt-1 mb-0">{{ consent.dict_consents.type_name }}</h2>
                </div>
            </div>
            <div class="modal-body p-4 border-top text-center">
                <p>{{ consent.dict_consents.content }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        consent() {
            return this.$store.getters.modalState.args.data
        }
    }
}
</script>